const labels = new Map([
  ["Surg", "Surgery"],
  ["Rad", "Radiation"],
  ["Both", "Surgery + Radiation"],
  ["AllSamples", "All Samples"],
]);

// Format display text only; retain the API value for filters and requests.
export const surgeryRadiationLabel = (value) => labels.get(value) ?? value;
